/**
 * Report-maker "dashboard" data source: reuse the same KPI / hierarchy
 * datasets that used to live only on dedicated level dashboards.
 */

export const DASHBOARD_DATA_SOURCE = 'dashboard';

export const DASHBOARD_SLICES = [
  {
    value: 'metrics',
    label: 'شاخص‌های KPI (یک ردیف)',
    description: 'متغیرهای فرمول داشبورد: فروش، تارگت، مشتری، مرجوعی، …',
  },
  {
    value: 'unit_sales',
    label: 'فروش به تفکیک واحد',
    description: 'کارتن / ظرف / تناژ با مقدار، هدف و درصد',
  },
  {
    value: 'brands',
    label: 'سهم برندها',
    description: 'فروش تجمیعی هر تولیدکننده',
  },
  {
    value: 'breakdown',
    label: 'رتبه‌بندی پرسنل / گروه‌ها',
    description: 'فروشنده: گروه‌کالا؛ سطوح بالاتر: افراد زیرمجموعه',
  },
  {
    value: 'trend',
    label: 'روند ۶ ماه',
    description: 'فروش و مشتری شش ماه اخیر',
  },
  {
    value: 'target_groups',
    label: 'گزارش تارگت (گروه کالا)',
    description: 'هر ردیف = پرسنل × گروه کالا با فروش و هدف',
  },
  {
    value: 'target_personnel',
    label: 'گزارش تارگت (خلاصه پرسنل)',
    description: 'جمع فروش و مشتری هر فرد زیرمجموعه',
  },
];

export const DASHBOARD_SLICE_FIELDS = {
  metrics: [
    { key: 'targeted_sales', fa: 'فروش گروه‌های دارای تارگت' },
    { key: 'sale_target', fa: 'جمع تارگت فروش' },
    { key: 'sale_pct', fa: 'درصد تحقق فروش' },
    { key: 'total_sales', fa: 'کل فروش' },
    { key: 'total_customers', fa: 'مشتری فعال' },
    { key: 'customer_count', fa: 'مشتری فعال (مترادف)' },
    { key: 'customer_count_month', fa: 'تعداد مشتری ماه (سطح دوره)' },
    { key: 'customer_target', fa: 'جمع تارگت مشتری' },
    { key: 'customer_pct', fa: 'درصد تحقق مشتری' },
    { key: 'customer_target_month', fa: 'هدف کل مشتری ماه' },
    { key: 'targeted_customers', fa: 'مشتری گروه‌های دارای تارگت' },
    { key: 'financial_claims', fa: 'مطالبات مالی' },
    { key: 'total_net_amount', fa: 'فروش خالص ریالی' },
    { key: 'net_after_return', fa: 'خالص بعد از مرجوعی' },
    { key: 'net_amount', fa: 'مبلغ خالص' },
    { key: 'net_pack_qty', fa: 'کارتن خالص' },
    { key: 'total_gross_carton', fa: 'کارتن ناخالص' },
    { key: 'total_net_carton', fa: 'کارتن خالص (تجمیع)' },
    { key: 'total_return_carton', fa: 'کارتن مرجوعی تجمیع' },
    { key: 'net_qty', fa: 'مقدار خالص / ظرف' },
    { key: 'net_weight_kg', fa: 'وزن خالص کیلوگرم' },
    { key: 'net_weight_ton', fa: 'وزن خالص تناژ' },
    { key: 'return_pack_qty', fa: 'کارتن مرجوعی' },
    { key: 'invoice_count', fa: 'تعداد فاکتور' },
    { key: 'seller_count', fa: 'تعداد فروشنده' },
    { key: 'supervisor_count', fa: 'تعداد سرپرست' },
    { key: 'brand_count', fa: 'تعداد برند' },
    { key: 'f_sale_target', fa: 'تارگت فروش برنامه' },
    { key: 'f_customer_target', fa: 'تارگت مشتری برنامه' },
    { key: 'sales_carton', fa: 'فروش کارتن (تارگت‌دار)' },
    { key: 'sales_qty', fa: 'فروش ظرف (تارگت‌دار)' },
    { key: 'sales_weight', fa: 'فروش تناژ (تارگت‌دار)' },
    { key: 'target_carton', fa: 'تارگت کارتن' },
    { key: 'target_qty', fa: 'تارگت ظرف' },
    { key: 'target_weight', fa: 'تارگت تناژ' },
    { key: 'percent_return_carton', fa: 'درصد کارتن مرجوعی' },
    { key: 'achievement_gap_sale', fa: 'فاصله تا تارگت فروش' },
    { key: 'achievement_gap_customer', fa: 'فاصله تا تارگت مشتری' },
    { key: 'commission_paid', fa: 'پورسانت پرداختی' },
    { key: 'commission_allocated', fa: 'پورسانت مصوب' },
    { key: 'commission_sale', fa: 'پورسانت تارگت فروش' },
    { key: 'commission_return', fa: 'پورسانت مرجوعی' },
    { key: 'commission_active', fa: 'پورسانت تارگت اکتیو مشتریان' },
    { key: 'commission_claims', fa: 'پورسانت مطالبات' },
    { key: 'commission_entry_passed', fa: 'شرط ورود پورسانت' },
    { key: 'commission_basket_achievement', fa: 'درصد تحقق سبد حجمی' },
  ],
  unit_sales: [
    { key: 'unit', fa: 'واحد' },
    { key: 'unit_key', fa: 'کلید واحد' },
    { key: 'qty', fa: 'مقدار' },
    { key: 'target', fa: 'هدف' },
    { key: 'pct', fa: 'درصد' },
  ],
  brands: [
    { key: 'brand', fa: 'برند' },
    { key: 'sales', fa: 'فروش' },
    { key: 'unit', fa: 'واحد' },
  ],
  breakdown: [
    { key: 'name', fa: 'نام' },
    { key: 'sales', fa: 'فروش' },
    { key: 'sale_target', fa: 'هدف فروش' },
    { key: 'sale_pct', fa: 'تحقق فروش' },
    { key: 'customers', fa: 'مشتری' },
    { key: 'customer_target', fa: 'هدف مشتری' },
    { key: 'customer_pct', fa: 'تحقق مشتری' },
    { key: 'id', fa: 'شناسه' },
  ],
  trend: [
    { key: 'year_number', fa: 'سال' },
    { key: 'month_number', fa: 'ماه' },
    { key: 'sales', fa: 'فروش' },
    { key: 'customers', fa: 'مشتری' },
    { key: 'net_amount', fa: 'مبلغ خالص' },
    { key: 'return_pack_qty', fa: 'کارتن مرجوعی' },
  ],
  target_groups: [
    { key: 'personnel_name', fa: 'پرسنل' },
    { key: 'personnel_code', fa: 'کد پرسنلی' },
    { key: 'manufacturer_product', fa: 'برند — گروه کالا' },
    { key: 'manufacturer_name', fa: 'برند' },
    { key: 'product_group_name', fa: 'گروه کالا' },
    { key: 'unit_type', fa: 'واحد' },
    { key: 'sales_qty', fa: 'فروش' },
    { key: 'f_sale_target', fa: 'هدف فروش' },
    { key: 'sale_pct', fa: 'تحقق فروش' },
    { key: 'customer_count', fa: 'مشتری' },
    { key: 'f_customer_target', fa: 'هدف مشتری' },
    { key: 'customer_pct', fa: 'تحقق مشتری' },
    { key: 'net_amount', fa: 'مبلغ خالص' },
  ],
  target_personnel: [
    { key: 'name', fa: 'پرسنل' },
    { key: 'personnel_code', fa: 'کد پرسنلی' },
    { key: 'sales', fa: 'فروش' },
    { key: 'sale_target', fa: 'هدف فروش' },
    { key: 'sale_pct', fa: 'تحقق فروش' },
    { key: 'customers', fa: 'مشتری' },
    { key: 'customer_target', fa: 'هدف مشتری' },
    { key: 'customer_pct', fa: 'تحقق مشتری' },
    { key: 'item_count', fa: 'تعداد گروه' },
  ],
};

export function isDashboardDataSource(widget) {
  const src = widget?.dataSource;
  return src === DASHBOARD_DATA_SOURCE || src === 'formula';
}

export function dashboardSliceOf(widget) {
  const slice = String(widget?.dashboardSlice || 'metrics').trim();
  return DASHBOARD_SLICES.some((s) => s.value === slice) ? slice : 'metrics';
}

export function dashboardSliceFields(slice) {
  return DASHBOARD_SLICE_FIELDS[slice] || DASHBOARD_SLICE_FIELDS.metrics;
}

export function dashboardSliceKeys(slice) {
  return dashboardSliceFields(slice).map((f) => f.key);
}

/** Sample metrics row so designer preview can evaluate formulas. */
export function sampleDashboardMetrics(rowIndex = 0) {
  const n = rowIndex + 1;
  return {
    targeted_sales: 4200 * n,
    sale_target: 5000 * n,
    sale_pct: 84,
    total_sales: 4500 * n,
    total_customers: 118 * n,
    customer_count: 118 * n,
    customer_count_month: 80 * n,
    customer_target: 140 * n,
    customer_pct: 84,
    customer_target_month: 100 * n,
    targeted_customers: 110 * n,
    financial_claims: 50000000 * n,
    total_net_amount: 200000000 * n,
    net_after_return: 200000000 * n,
    net_amount: 200000000 * n,
    net_pack_qty: 4100 * n,
    total_gross_carton: 100 * n,
    total_net_carton: 75 * n,
    total_return_carton: 25 * n,
    net_qty: 18000 * n,
    net_weight_kg: 3200 * n,
    net_weight_ton: 3.2 * n,
    return_pack_qty: 180 * n,
    invoice_count: 96 * n,
    seller_count: 8,
    supervisor_count: 2,
    brand_count: 12,
    f_sale_target: 5000 * n,
    f_customer_target: 140 * n,
    sales_carton: 3800 * n,
    sales_qty: 900 * n,
    sales_weight: 2.1 * n,
    target_carton: 4500 * n,
    target_qty: 1000 * n,
    target_weight: 2.5 * n,
    percent_return_carton: 4.4,
    achievement_gap_sale: 800 * n,
    achievement_gap_customer: 22 * n,
    commission_paid: 41160000 * n,
    commission_allocated: 280000000,
    commission_sale: 41160000 * n,
    commission_return: 0,
    commission_active: 0,
    commission_claims: 0,
    commission_entry_passed: n > 1 ? 1 : 0,
    commission_basket_achievement: 49,
  };
}

export function sampleUnitSales() {
  return [
    { unit: 'کارتن', unit_key: 'carton', qty: 3800, target: 4500, pct: 84 },
    { unit: 'ظرف', unit_key: 'qty', qty: 900, target: 1000, pct: 90 },
  ];
}
